const Form_init = require("./src/Form_init");

module.exports = class DownloadForm {
    constructor($form) {
        Form_init($form[0]);
    }
};